// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_HOMEPAGE = "Zp\u011bt na hlavn\u00ed str\u00e1nku";
export const PROFILE_PRODUCTS_TITLE = "Produkty na m\u00e9m profilu";
export const USER_STROLLERS_MY_STROLLERS = "Moje ko\u010d\u00e1rky";
